import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import FileUpload from "components/ui/input/FileUpload";
import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";
import { useForm } from "shared/hooks/form-hook";

const FileUploadSection = ({
  accept,
  disabled,
  isFileAnalyzing,
  onAnalyze,
  exampleFileName,
  instructionText,
  analyzingText,
  uploadedFileText,
  selectedFile,
}) => {
  const { t } = useTranslation();

  const [formState, inputHandler] = useForm(
    {
      file: { value: null, isValid: true },
    },
    true
  );

  useEffect(() => {
    if (selectedFile) {
      inputHandler("file", selectedFile, true);
    }
  }, [selectedFile, inputHandler]);

  return (
    <div
      style={{
        maxWidth: "650px",
        width: "100%",
      }}
    >
      <div style={{ marginBottom: "20px" }}>{instructionText || t("fileUploadSection.instruction")}</div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "30px",
          justifyContent: "flex-start",
          marginTop: "20px",
          marginBottom: "20px",
        }}
      >
        <div>
          <FileUpload
            id="file"
            onInput={(id, value) => {
              if (value.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
                window.toast.error("Please upload a valid Excel file");
                return;
              }
              inputHandler(id, value, true);
              onAnalyze(value);
              //setAnalyzedFor(value);
            }}
            disabled={disabled}
            exampleFileName={exampleFileName || null}
            accept={accept}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          {isFileAnalyzing && (
            <div style={{ display: "flex", alignItems: "center", height: "40px" }}>
              <div style={{ transform: "scale(0.4)" }}>
                <LoadingSpinner />
              </div>
              <span style={{ color: "#1976d2", fontSize: "14px" }}>
                {analyzingText || t("fileUploadSection.analyzing")}
              </span>
            </div>
          )}
          {formState.inputs.file?.value && !isFileAnalyzing && (
            <p
              style={{
                marginTop: "0",
                marginBottom: "0",
                // paddingRight: "20px",
                fontSize: "14px",
                color: "#666",
              }}
            >
              {uploadedFileText || t("fileUploadSection.uploadedFile")}:{" "}
              {formState.inputs.file.value.name.length > 20
                ? formState.inputs.file.value.name.substring(0, 20) + "..."
                : formState.inputs.file.value.name}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileUploadSection;
